import request from '@/utils/request'

// 分类模块

// 分类列表
export function groupList() {
  return request({
    url: '/big/select/group',
    method: 'get'
  })
}